<template>
  <v-sheet
    class="d-flex align-center flex-column py-6 py-md-9 py-lg-12 px-3"
    color="primary"
  >
    <div class="white--text text-h5 text-md-h4 text-center">
      {{ title }}
    </div>

    <LoadingWidget v-if="checking" />

    <template v-else>
      <LoginForm v-if="!auth" class="mt-4 mt-md-6" />

      <ButtonWidget
        v-else
        class="mt-4 mt-md-6"
        text-color="white"
        to="/pesquisas"
        align="center"
      >
        Minhas Pesquisas
      </ButtonWidget>
    </template>
  </v-sheet>
</template>

<script>
import LoadingWidget from "../widgets/LoadingWidget.vue";
import LoginForm from "../forms/LoginForm.vue";
import ButtonWidget from "../widgets/ButtonWidget.vue";

const _data = {
  title: "Acesse suas Pesquisas",
  checking: true,
  auth: false,
};

export default {
  data: () => ({
    ..._data,
  }),
  methods: {
    checkIn() {
      this.checking = true;

      const token = window.localStorage.getItem(`token`);

      if (token) {
        this.$auth
          .checkIn()
          .then(() => {
            if (this.$auth.on) this.auth = true;
          })
          .finally(() => (this.checking = false));
      } else {
        this.checking = false;
      }
    },
  },
  watch: {
    $route() {
      this.checkIn();
    },
  },
  created() {
    this.checkIn();
  },
  components: {
    LoadingWidget,
    LoginForm,
    ButtonWidget,
  },
};
</script>
